import {CategoryType} from '../constants';
import {CategoryIdTypeLabel} from '../locales';

export const getCategoryIdTypeLabel = (type: CategoryType) =>
	CategoryIdTypeLabel[type];

export default getCategoryIdTypeLabel;
